const VIRTUAL_NAMED_GRAPH_PREFIX = 'virtual://';

export const isVirtualNamedGraphIri = (iri: string) =>
  iri.startsWith(VIRTUAL_NAMED_GRAPH_PREFIX);
